import moment from "moment";

interface CalculateMinMaxParams {
  initialDate: string;
  finalDate: string;
  duration?: number;
}

export function calculateMinMaxTeamStart({
  initialDate,
  finalDate,
  duration,
}: CalculateMinMaxParams) {
  const today = moment().startOf("day");
  const inputStart = moment(initialDate, "YYYY-MM-DD").startOf("day");

  //  Regra 1: Se start < hoje → start = hoje
  const start = inputStart.isBefore(today) ? today.clone() : inputStart.clone();
  const end = calculateEndInput({
    finalDate,
    duration,
    start,
  });

  const totalDays = end.diff(start, "days");

  // Regra 2: Se start original < hoje && duration && sem finalDate → min = 1
  let min = inputStart.isBefore(today) && duration ? 1 : today.diff(inputStart, "days") + 1;

  const oneDayResult = handleOneDayInterval(totalDays, start, today);
  if (oneDayResult) return oneDayResult;

  if (start.isSame(end)) {
    return handleSameDay(start, today, min);
  }

  if (totalDays < 1 && today.isBefore(start)) {
    return { min: null, max: null };
  }

  return { min, max: calculateMax({ today, start, end, totalDays }) };
}

export function calculateMinMaxTeamEnd({
  initialDate,
  finalDate,
  duration,
}: CalculateMinMaxParams) {
  const initial = moment(initialDate, "YYYY-MM-DD").startOf("day");
  const final = moment(finalDate, "YYYY-MM-DD").startOf("day");
  const today = moment().startOf("day");
  let min: number | undefined;
  if (duration) {
    // Usamos - 2 pq desconsideramos o dia do inicio e o dia do fim
    min = duration - 2;
  } else {
    min = final.diff(initial, "days") - 1;
  }
  min = min * -1;
  return { min: initial.isSame(today, "day") && min === 0 ? null : min, max: 365 };
}

const calculateEndInput = ({
  finalDate,
  duration,
  start,
}: {
  finalDate: string;
  duration?: number;
  start: moment.Moment;
}) => {
  let endInput = finalDate ? moment(finalDate, "YYYY-MM-DD").startOf("day") : null;

  if (duration) {
    const startPlusDuration = start.clone().add(duration - 1, "days");

    if (endInput) {
      if (startPlusDuration.isBefore(endInput)) {
        endInput = startPlusDuration;
      }
    } else {
      endInput = startPlusDuration;
    }
  }

  return endInput;
};

const handleOneDayInterval = (totalDays: number, start: moment.Moment, today: moment.Moment) => {
  if (totalDays !== 1) return null;

  const daysUntilStart = start.diff(today, "days");

  if (daysUntilStart === 1) {
    return { min: 0, max: 0 };
  }

  return null;
};

const handleSameDay = (start: moment.Moment, today: moment.Moment, min: number) => {
  const futureDays = start.diff(today, "days");
  if (futureDays <= 1) {
    return { min: null, max: null };
  }
  return { min, max: -1 };
};

const calculateMax = ({
  today,
  start,
  end,
  totalDays,
}: {
  today: moment.Moment;
  start: moment.Moment;
  end: moment.Moment;
  totalDays: number;
}) => {
  if (today.isBefore(start)) return totalDays - 1;
  if (today.isSameOrAfter(end)) return -1;
  return end.diff(today, "days") - 1;
};

